import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(client)/layout.tsx");
